import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialFormIdentityByIdRequest,
    type GetTrialFormIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useTrialFormIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetTrialFormIdentityByIdResponse,
        GetTrialFormIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetTrialFormIdentityByIdResponse> =>
            new GetTrialFormIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetTrialFormIdentityByIdResponse>) =>
                response?.data?.trialFormIdentity,
            getError: (response?: SWRResponse<GetTrialFormIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useTrialFormIdentityById;
